// extracted by mini-css-extract-plugin
export var productImage = "_106-0";